@if (show) {
  <theme-root [buildNumber]="buildNumber"></theme-root>
}
